import { foldazApi, graphqlApi } from 'api'

import { apolloClient } from '@/graphql/apollo'
import getMailingGql from '@/graphql/query/getMailingGql.gql'
import getLatestMailingGql from '@/graphql/query/getLatestMailingGql.gql'
import folderTagsGql from '@/graphql/query/folderTagsGql.gql'
import recipientsGql from '@/graphql/query/recipientsGql.gql'

import {
  SET_MAILING_ID,
  SET_FOLDER_ID,
  SET_GROUPED_CONTENTS,
  SET_GROUPBY_TAGS,
  SELECT_TAG,
  SELECT_CONTENT,
  SELECT_ALL_CONTENTS,
  SELECT_RECIPIENT,
  SELECT_ALL_RECIPIENTS,
  SET_CONTENTS,
  SET_TAG_CONTENTS,
  SET_RECIPIENTS,
  SET_PREVIEW_RECIPIENTS,
  SET_SUBJECT,
  SET_INTRO_TEXT
} from './types'

export const state = {
  mailingId: null,
  folderId: null,
  subject: '',
  introText: '',
  contents: [],
  groupedContents: null,
  groupByTags: false,
  recipients: [],
  previewRecipients: []
}

export const mutations = {
  [SET_MAILING_ID] (state, value) {
    state.mailingId = value
  },
  [SET_GROUPED_CONTENTS] (state, value) {
    state.groupedContents = value
  },
  [SET_CONTENTS] (state, value) {
    state.contents = value
  },
  [SET_RECIPIENTS] (state, value) {
    state.recipients = value
  },
  [SET_PREVIEW_RECIPIENTS] (state, value) {
    state.previewRecipients = value
  },
  [SET_FOLDER_ID] (state, value) {
    state.folderId = value
  },
  [SET_GROUPBY_TAGS] (state, value) {
    state.groupByTags = value
  },
  [SET_TAG_CONTENTS] (state, {tag, contents}) {
    const tagIndex = state.groupedContents.findIndex(entry => entry.id === tag.id)
    state.groupedContents[tagIndex].contents = contents
  },
  [SELECT_TAG] (state, value) {
    const entry = state.groupedContents.find(tag => tag.id === value.id)
    entry['selected'] = !entry['selected']
    // reset contents
    if (entry['selected'] === false) {
      const tagIndex = state.groupedContents.findIndex(entry => entry.id === value.id)
      state.groupedContents[tagIndex].contents.map(content => {
        content.selected = false
      })
    }
  },
  [SELECT_CONTENT] (state, {tag, content}) {
    if (tag === undefined) {
      const contentIndex = state.contents.findIndex(entry => entry.id === content.id)
      var entry = state.contents[contentIndex]
    } else {
      const tagIndex = state.groupedContents.findIndex(entry => entry.slug === tag.slug)
      const contentIndex = state.groupedContents[tagIndex].contents.findIndex(entry => entry.id === content.id)
      var entry = state.groupedContents[tagIndex].contents[contentIndex]
    }

    entry['selected'] = !entry['selected']
  },
  [SELECT_ALL_CONTENTS] (state, value) {
    state.contents.map(entry => entry['selected'] = value)
  },
  [SELECT_RECIPIENT] (state, value) {
    const index = state.recipients.findIndex(recipient => recipient.email === value.email)
    const entry = state.recipients[index]
    entry['selected'] = !entry['selected']
  },
  [SELECT_ALL_RECIPIENTS] (state, value) {
    state.recipients.map(entry => entry['selected'] = value)
  },
  [SET_SUBJECT] (state, value) {
    state.subject = value
  },
  [SET_INTRO_TEXT] (state, value) {
    state.introText = value
  }
}

export const actions = {
  setGroupedContents ({ commit, dispatch }, value) {
    commit(SET_GROUPED_CONTENTS, value)
    dispatch('saveMailing')
  },
  setMailingId ({ commit }, value) {
    commit(SET_MAILING_ID, value)
  },
  setFolderId ({ commit }, value) {
    commit(SET_FOLDER_ID, value)
  },
  setSubject ({ commit }, value) {
    commit(SET_SUBJECT, value)
  },
  setGroupByTags ({ commit, dispatch }, value) {
    commit(SET_GROUPBY_TAGS, value)
    dispatch('saveMailing')
  },
  setIntroText ({ commit }, value) {
    commit(SET_INTRO_TEXT, value)
  },
  setContents ({ commit, dispatch }, value) {
    commit(SET_CONTENTS, value)
    dispatch('saveMailing')
  },
  setTagContents ({ commit, dispatch }, value) {
    commit(SET_TAG_CONTENTS, value)
    dispatch('saveMailing')
  },
  setPreviewRecipients ({ commit, dispatch }, value) {
    commit(SET_PREVIEW_RECIPIENTS, value)
    dispatch('saveMailing')
  },
  selectContent ({ commit, dispatch }, payload) {
    commit(SELECT_CONTENT, payload)
    dispatch('saveMailing')
  },
  selectAllContents ({ commit, dispatch }, payload) {
    commit(SELECT_ALL_CONTENTS, payload)
    dispatch('saveMailing')
  },
  selectAllRecipients ({ commit, dispatch }, payload) {
    commit(SELECT_ALL_RECIPIENTS, payload)
    dispatch('saveMailing')
  },
  selectTag ({ commit, dispatch }, value) {
    commit(SELECT_TAG, value)
    dispatch('rebuildContent')
    dispatch('saveMailing')
  },
  selectRecipient ({ commit, dispatch }, value) {
    commit(SELECT_RECIPIENT, value)
    dispatch('saveMailing')
  },
  rebuildContent ({ commit, getters }) {
    let contents = []
    getters.selectedTags.map(tag => {
      contents = contents.concat([...tag.contents])
    })

    commit(SET_CONTENTS, contents.filter((content, index, self) => self.findIndex(t => t.id === content.id) === index))
  },
  fetchMailing ({}, mailingId) {
    console.log('store:mailing:fetchMailing', mailingId)

    return apolloClient.query({
      query: getMailingGql,
      variables: {
        id: mailingId
      }
    })
  },
  loadMailing ({ commit, dispatch }, payload) {
    return dispatch('fetchMailing', payload.id)
      .then(({data}) => {
        console.log('store:mailing:loadMailing', payload.id, data)

        const vuexState = data['GetMailing'].vuexState

        commit(SET_MAILING_ID, vuexState.mailingId)
        commit(SET_CONTENTS, vuexState.contents)
        commit(SET_GROUPED_CONTENTS, vuexState.groupedContents)
        commit(SET_RECIPIENTS, vuexState.recipients)
        commit(SET_PREVIEW_RECIPIENTS, vuexState.preview_recipients)
        commit(SET_GROUPBY_TAGS, vuexState.groupByTags)
        commit(SET_SUBJECT, vuexState.subject)
        commit(SET_INTRO_TEXT, vuexState.introText)
        dispatch('mailing/step/setIndex', 1, { root: true })
      })
  },
  fetchLatestMailing ({}, folderId) {
    return apolloClient.query({
      query: getLatestMailingGql,
      variables: {
        id: folderId
      }
    })
  },
  destroyMailing ({ commit }, mailingId) {
    return foldazApi.delete(`/mailings/${mailingId}`)
  },
  init ({ state, commit, dispatch }) {
    const folderId = state.folderId

    // tags & content
    const request1 = apolloClient.query({
      query: folderTagsGql,
      variables: {
        id: folderId
      }
    }).then(({ data }) => {
      // add selected prop
      data['FolderTags'].map(tag => {
        tag['selected'] = true
        tag.contents.map(content => content['selected'] = true)
        tag.contents = tag.contents.filter(content => content.folder.id === folderId)
      })

      let contents = []
      data['FolderTags'].map(tag => {
        contents = contents.concat([...tag.contents])
      })

      commit(SET_CONTENTS, contents.filter((content, index, self) => self.findIndex(t => t.id === content.id) === index))
      commit(SET_GROUPED_CONTENTS, data['FolderTags'])
    })
    .catch(error => console.log(error))

    // recipients
    const request2 = apolloClient.query({
      query: recipientsGql,
      variables: {
        id: folderId
      }
    }).then(({ data }) => {
      // add selected prop
      data['Recipients'].map(recipient => {
        recipient['selected'] = true
      })

      commit(SET_RECIPIENTS, data['Recipients'])
    })
    .catch(error => console.log(error))

    Promise.all([request1, request2]).then(() => {
      dispatch('saveMailing')
    }, error => {
      console.log(error)
    })
  },
  createMailing ({ state, dispatch }) {
    return foldazApi.post('/mailings', {
      mailing: {
        folder_id: state.folderId,
        vuex_state: state
      }
    }).then(({data}) => {
      dispatch('setMailingId', data.id)
      dispatch('init')
    })
  },
  saveMailing ({ state }) {
    return foldazApi.put(`/mailings/${state.mailingId}`, {
      mailing: {
        id: state.mailingId,
        vuex_state: state // TODO: cleanup, only used fields
      }
    })
  },
  publishMailing ({ state }, {perform}) {
    return foldazApi.put(`/mailings/${state.mailingId}`, {
      mailing: {
        id: state.mailingId,
        vuex_state: state, // TODO: cleanup, only used fields
        perform: perform // preview | publish
      }
    })
  },
  reset ({ commit }) {
    commit(SET_FOLDER_ID, null)
    commit(SET_MAILING_ID, null)
    commit(SET_CONTENTS, [])
    commit(SET_GROUPED_CONTENTS, [])
    commit(SET_RECIPIENTS, [])
    commit(SET_GROUPBY_TAGS, false)
    commit(SET_SUBJECT, '')
    commit(SET_INTRO_TEXT, '')
  },
}

export const getters = {
  selectedTags (state) {
    return state.groupedContents
      ? state.groupedContents.filter(entry => entry.selected === true)
      : []
  },
  isTagSelected (state) {
    return tag => {
      return state.groupedContents.find(entry => entry.slug === tag.slug)['selected']
    }
  },
  isContentSelected (state) {
    return ({tag, content}) => {
      if (tag === undefined) {
        return state.contents.find(entry => entry.id === content.id)['selected']
      } else {
        const index = state.groupedContents.findIndex(entry => entry.slug === tag.slug)
        return state.groupedContents[index].contents.find(entry => entry.id === content.id)['selected']
      }
    }
  },
  selectedContent (state) {
    if (state.groupByTags) {
      return state.groupedContents.map(tag => tag.contents.filter(entry => entry.selected === true)).flat()
    } else {
      return state.contents.filter(entry => entry.selected === true)
    }
  },
  groupedContentSelected (state) {
    return tag => {
      const index = state.groupedContents.findIndex(entry => entry.slug === tag.slug)
      return state.groupedContents[index].contents.filter(entry => entry.selected === true)
    }
  },
  selectedRecipients (state) {
    return state.recipients
      ? state.recipients.filter(entry => entry.selected === true)
      : []
  },
  isRecipientSelected (state) {
    return recipient => {
      return state.recipients.find(entry => entry.email === recipient.email)['selected']
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/mailings/mailing.js